import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
const MODULE_IMAGE = 'https://cdn.magicpatterns.com/uploads/grmPZ3aso86TigHoByUnZt/be25673f9b64d59f34f2ef36f5cad40c.jpg';
export const WhatYouGet = () => {
  const modules = [{
    num: '01',
    title: 'Materiales y Proveedores',
    desc: 'Qué comprar, dónde y al mejor precio.',
    bullets: ['Lista de proveedores confiables', 'Materiales esenciales (sin gastar de más)', 'Errores comunes que debés evitar'],
    img: MODULE_IMAGE
  }, {
    num: '02',
    title: 'Creación de Velas Aesthetic',
    desc: 'El paso a paso para velas premium en casa.',
    bullets: ['Técnicas sin hundimientos', 'Aromas duraderos y combinaciones', 'Acabados nivel marca premium'],
    img: MODULE_IMAGE
  }, {
    num: '03',
    title: 'Estrategia de Ventas',
    desc: 'Dejá de venderle solo a amigos y familia.',
    bullets: ['Cómo atraer clientas reales', 'Cierre de ventas sin presionar', 'Sistema de pedidos organizado'],
    img: MODULE_IMAGE
  }, {
    num: '04',
    title: 'Instagram Magnético',
    desc: 'Transformá tu perfil en una tienda irresistible.',
    bullets: ['Fotos que detienen el scroll', 'Reels virales paso a paso', 'Copys que venden sin sonar desesperada'],
    img: MODULE_IMAGE
  }, {
    num: '05',
    title: 'Precios y Ganancias',
    desc: 'Cobrá lo justo y ganá de verdad.',
    bullets: ['Fórmula exacta de costo', 'Margen de ganancia ideal', 'Cómo escalar tus ingresos'],
    img: MODULE_IMAGE
  }];
  return <section className="py-24 bg-white" data-id="element-235">
      <div className="max-w-4xl mx-auto px-6" data-id="element-236">
        <FadeIn className="text-center mb-16" data-id="element-237">
          <span className="inline-block text-sm font-semibold tracking-widest uppercase text-accent-rose-deep mb-4" data-id="element-238">
            El programa completo
          </span>
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-239">
            5 módulos. <span className="italic" data-id="element-240">1 sistema.</span>
          </h2>
          <p className="text-lg text-text-brown/70" data-id="element-241">
            Todo lo que necesitás para empezar desde cero.
          </p>
        </FadeIn>

        <div className="space-y-8" data-id="element-242">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.05} direction="up" data-id="element-243">
              <div className="flex flex-col md:flex-row gap-6 bg-cream rounded-3xl p-6 border border-nude hover:shadow-soft transition-shadow" data-id="element-244">
                <div className="w-full md:w-1/3 aspect-video md:aspect-square rounded-2xl overflow-hidden shrink-0" data-id="element-245">
                  <img src={mod.img} alt={mod.title} className="w-full h-full object-cover" data-id="element-246" />
                </div>
                <div className="flex flex-col justify-center flex-1" data-id="element-247">
                  <div className="flex items-center gap-3 mb-3" data-id="element-248">
                    <span className="text-accent-rose-deep font-serif text-3xl md:text-4xl font-bold" data-id="element-249">
                      {mod.num}
                    </span>
                    <div className="h-px flex-1 bg-nude" data-id="element-250" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2 leading-tight" data-id="element-251">
                    {mod.title}
                  </h3>
                  <p className="text-text-brown/80 mb-4 italic" data-id="element-252">{mod.desc}</p>
                  <ul className="space-y-2" data-id="element-253">
                    {mod.bullets.map((b, j) => <li key={j} className="flex items-start gap-2 text-sm text-text-brown" data-id="element-254">
                        <Check className="w-4 h-4 text-accent-rose-deep shrink-0 mt-0.5" data-id="element-255" />
                        <span data-id="element-256">{b}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};